module.exports = __webpack_public_path__ + "static/media/NEWMBAT-logo.92f2a62f.png";